import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import ProductsRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Products/Renderer/ProductsRenderer'

const ProductsForm = lazyLoad(() => import('./Form/ProductsForm'))

const productsPlugin = settings =>
    createPlugin({
        Renderer: ProductsRenderer,
        Controls: ProductsForm,
        ...settings,
    })

const products = productsPlugin()
export default products

export { productsPlugin, ProductsRenderer }
